var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-class=\"{bssskippedfield: to.skipField}\" ng-if=\"!to.skipField\">\n<div class=\"{{to.className}}\">\n<formly-transclude></formly-transclude>\n</div>\n</div>";
var id1="bssbase.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;